// Vendor imports
const React = require('react')
const { Route, Switch } = require('react-router-dom')
// Shared imports
const BemEntity = require('shared/bem')
// Common V2 imports
const withCommonRoot = require('client-v2/common/components/root')
const AppNav = require('client-v2/common/containers/app-nav/component-smart')
const ArticleProfileModal = require('client-v2/common/containers/article-profile/components/modal-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
const FeedAwareAppFooter = require('client-v2/common/containers/feed/app-footer').default
const OpenInAppButton = require('client-v2/common/containers/open-in-app-button/component-smart')
// Entry imports
const SearchAwareAppHeader = require('../containers/app-header/component-smart')
const SearchDomainHeader = require('../containers/domain-header/component-smart')
const SearchFeed = require('../containers/feed/component-smart')
const SearchNav = require('../containers/nav/component-smart')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('SearchLayout')

class SearchLayout extends React.PureComponent {
  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        tag('div', {
          className: bem.element('page')
        },
          tag(SearchAwareAppHeader, {
            className: bem.element('header')
          }),
          tag('div', {
            className: bem.element('body')
          },
            tag(Switch, null,
              tag(Route, {
                path: '/search/:query/domain',
                component: SearchDomainHeader
              }),
              tag(Route, {
                path: '/search/:query',
                component: SearchNav
              })
            ),
            tag(SearchFeed)
          ),
          tag(FeedAwareAppFooter),
          tag(AppNav, {
            className: 'AppNav--mobile'
          })
        ),
        tag(ArticleProfileModal),
        tag(OpenInAppButton),
        tag(AuthModal)
      )
    )
  }
}

module.exports = withCommonRoot(SearchLayout)
